import { Link } from "react-router-dom";
import { getFeaturedArticles } from "@/mocks/articles";
import { getCategoryBySlug } from "@/mocks/categories";

export default function HomeFeatured() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
              精选推荐
            </h2>
            <p className="text-sm text-foreground-600">
              编辑团队精心挑选的优质内容
            </p>
          </div>
          <Link
            to="/category/zhibo-zixun"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featured.map((article) => {
            const cat = getCategoryBySlug(article.category);
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col sm:flex-row gap-5 p-5 rounded-xl bg-background-50 hover:bg-background-200/30 transition-all duration-300 cursor-pointer"
              >
                <div className="w-full sm:w-48 h-40 sm:h-32 flex-shrink-0 overflow-hidden rounded-lg">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`糖果直播-${article.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex flex-col justify-between flex-1 min-w-0">
                  <div>
                    <span className="inline-block px-2.5 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-2 whitespace-nowrap">
                      {cat?.name || "资讯"}
                    </span>
                    <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                    <span>{article.author}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span>{article.date}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}